export default {"src":"/_next/static/media/review-empty-star.12ad210b.svg","height":16,"width":16};